import React, { useState } from 'react';
import { THEME_IDS } from './themes';
import { applyTheme } from './applyTheme';

export function DevThemeSwitcher(): JSX.Element | null {
  const [brand, setBrand] = useState('#005f73');
  if (process.env.NODE_ENV !== 'development') return null;
  return (
    <div style={{ position: 'fixed', bottom: 12, right: 12, zIndex: 9999,
      background: '#fff', border: '1px solid #ccc', borderRadius: 8, padding: 8,
      display: 'flex', gap: 6, alignItems: 'center', boxShadow: '0 4px 12px rgba(0,0,0,.15)' }}>
      {THEME_IDS.map((id) => (
        <button key={id} type="button" onClick={() => applyTheme(id, brand)}>{id}</button>
      ))}
      <input aria-label="brand color" value={brand} onChange={(e) => setBrand(e.target.value)} />
    </div>
  );
}
